import { stringify } from "querystringify"

import {
    psychologistTitles,
    getFaceUrl,
    getLowestServicePrice,
} from "utils/helpers/psychologistUtil"
import { Psychologist } from "utils/interfaces"
import { isBrowser } from "utils/infrastructure/ssg-utils"
import { CURRENCY } from "utils/constants"
import { Attributes } from "utils/analytics/funnels"

export function FBProduct({ psy }: { psy: Psychologist }) {
    const urlParams = { hash_ids: psy.hash_id }
    const url = isBrowser()
        ? [
              document.location.origin,
              `/psychologist/${psy.hash_id}`,
              stringify(urlParams, true),
          ].join("")
        : null

    if (!isBrowser()) {
        return null
    }

    return (
        <script type="application/ld+json">
            {JSON.stringify(Object.assign({ url }, productSchema(psy)))}
        </script>
    )
}

function productSchema(psy: Psychologist) {
    return {
        "@context": "https://schema.org",
        "@type": "Product",
        productID: Attributes.psychologist.compute({ psy }),
        name: psy.display_name,
        description: psychologistTitles(psy).join(", "),
        image: getFaceUrl(psy.face_url, psy.hash_id),
        brand: "alter",
        offers: [
            {
                "@type": "Offer",
                price: getLowestServicePrice(psy.offered_services),
                priceCurrency: CURRENCY.RUB,
                itemCondition: "https://schema.org/NewCondition",
                availability: "https://schema.org/InStock",
            },
        ],
    }
}
